// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Regeneration_wrapper__1M35L","rekuperacjaImg":"Regeneration_rekuperacjaImg__2wHyX","text":"Regeneration_text__24R3Q"};